import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Popup } from 'devextreme-react/popup';
import { showWarnMessage, showInfoMessage, handleError } from '../../utils/Utility';
import WhiteLayout from '../../template/WhiteLayout';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import { Authenticate, IsLoggedIn } from '../../services/AccountService';
import API, { adminstrativeCompanyDataSource } from '../../services/AplicationService';
import * as messages from '../../utils/Messages';

const initialState = {
	disabled: false,
	isLoggedIn: false,
	message: { show: false, text: '' },
	forgetPassword: { show: false, email: '' },
	login: {
		email: '',
		password: '',
		reminder: false,
		administrativeCompanyId: null,
	},
};
export default class Login extends Component {
	state = { ...initialState };
	login = {
		email: '',
		password: '',
		reminder: false,
		administrativeCompanyId: null,
	};
	constructor(props) {
		super(props);
		this.onClickConfirm = this.onClickConfirm.bind(this);
		this.onKeyPress = this.onKeyPress.bind(this);
		this.showMessage = this.showMessage.bind(this);
		this.showForgetPassword = this.showForgetPassword.bind(this);
		this.onClickForgetPassword = this.onClickForgetPassword.bind(this);
		this.userLogin = this.userLogin.bind(this);
		this.form = React.createRef();
		this.sendEmailChangePassword = this.sendEmailChangePassword.bind(this);
	}

	userLogin() {
		this.setState({
			...this.state,
			disabled: true,
			message: { show: false, text: null },
		});

		let login = { ...this.login };
		let authentication = Authenticate(login.email, login.password, login.administrativeCompanyId, login.reminder);
		authentication.then(result => {
			if (result) {
				this.props.history.push('/home');
			} else {
				this.setState({
					...this.state,
					disabled: false,
				});
			}
		});
	}
	sendEmailChangePassword(key) {
		API.get('account/sendEmailPassword/' + key)
			.then(response => {
				this.setState({ ...this.state, forgetPassword: { show: false, email: '' } });
				showInfoMessage(
					'E-mail de alteração de senha enviado com sucesso. Acesse sua caixa e siga os procedimentos de alteração de senha. Lembre-se de verificar a caixa de spam do seu e-mail.'
				);
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			});
	}

	onKeyPress = function(event) {
		this.userLogin();
	};

	onClickConfirm = function() {
		this.userLogin();
	};
	onClickForgetPassword = function() {
		this.sendEmailChangePassword(this.state.forgetPassword.email);
	};
	componentDidMount() {
		let message = this.props.location.state
			? this.props.location.state.message
				? this.props.location.state.message
				: null
			: this.props.location.search
			? 'Sua sessão expirou ou você não está logado na aplicação. É necessário realizar o login.'
			: null;

		if (message) {
			setTimeout(
				() =>
					this.setState({
						...this.state,
						message: { show: true, text: message },
					}),
				20
			);
		}

		let isLoggedIn = IsLoggedIn();
		this.setState({ ...this.state, isLoggedIn: isLoggedIn });
	}
	showMessage = function() {
		if (this.state.message.show) {
			let message = this.state.message.text;
			showWarnMessage(message);
		}
	};
	showForgetPassword = function() {
		this.setState({ forgetPassword: { show: true, email: this.state.login.email } });
	};

	render(props) {
		let renderResult;
		if (!this.state.isLoggedIn) {
			renderResult = (
				<React.Fragment>
					<Popup
						visible={this.state.forgetPassword.show}
						onHiding={() => {
							this.setState({ forgetPassword: { show: false, email: '' } });
						}}
						height={'auto'}
						width={'30%'}
						dragEnabled={true}
						closeOnOutsideClick={false}
						showTitle={true}
						title={'Esqueceu a senha?'}
					>
						<Form formData={this.state.forgetPassword} showColonAfterLabel={false} labelLocation={'left'}>
							<GroupItem colCount={1}>
								<SimpleItem>
									<p>
										Preencha o seu e-mail e clique em enviar para receber um e-mail de alteração de
										senha.
									</p>
								</SimpleItem>
								<SimpleItem colSpan={1} dataField={'email'} label={{ text: 'Email' }} />
							</GroupItem>
							<SimpleItem colSpan={2}>
								<div className="pull-right">
									<button type="button" className="btn btn-info" onClick={this.onClickForgetPassword}>
										<i className="fa fa-envelope" />
										&nbsp; Enviar
									</button>
								</div>
							</SimpleItem>
						</Form>
					</Popup>
					<WhiteLayout>
						{this.showMessage()}
						<div className="general-box">
							<div className="general-box-header ">
								<img
									src={require('../../resources/images/logo.png')}
									style={{ width: '100%', height: 'auto' }}
									// className="img-fluid"
									alt="SENC App"
								/>
								{/* <strong>SENC</strong> App */}
							</div>
							<div className="general-box-body">
								<h3 className="text-center">Seja bem vindo!</h3>
								<p className="general-box-msg">Acesse o sistema com seu e-mail e senha.</p>
								<Form
									formData={this.login}
									ref={this.form}
									showColonAfterLabel={false}
									labelLocation={'top'}
									onEditorEnterKey={this.onKeyPress}
								>
									<SimpleItem
										dataField={'administrativeCompanyId'}
										editorType={'dxSelectBox'}
										cssClass="uppercase"
										colSpan={2}
										editorOptions={{
											dataSource: adminstrativeCompanyDataSource,
											valueExpr: 'id',
											displayExpr: 'corporateName',
											searchEnabled: true,
											searchModeOption: 'contains',
											searchTimeoutOption: 200,
											minSearchLengthOption: 2,
											showDataBeforeSearchOption: false,
										}}
										label={{ text: 'Empresa' }}
									/>
									<SimpleItem
										dataField={'email'}
										label={{ text: 'E-mail' }}
										editorOptions={{
											placeholder: 'digite aqui o seu e-mail',
										}}
									/>
									<SimpleItem
										dataField={'password'}
										label={{ text: 'Senha' }}
										editorOptions={{
											mode: 'password',
											placeholder: 'digite aqui a sua senha',
										}}
									/>

									<GroupItem colCount={3}>
										<SimpleItem
											dataField={'reminder'}
											editorType={'dxCheckBox'}
											label={{ text: 'lembrar', location: 'right' }}
										/>
										<SimpleItem colSpan={2}>
											<div className="pull-right">
												<button
													type="button"
													className="btn btn-info"
													disabled={this.state.disabled}
													onClick={this.onClickConfirm}
												>
													Entrar &nbsp; <i className="fa fa-angle-right" />
												</button>
											</div>
										</SimpleItem>
									</GroupItem>
									<GroupItem>
										<div className="pull-right">
											<a href="#" onClick={this.showForgetPassword}>
												esqueceu a senha?
											</a>
										</div>
									</GroupItem>
								</Form>
							</div>
						</div>
					</WhiteLayout>
				</React.Fragment>
			);
		} else {
			renderResult = (
				<Redirect
					to={{
						pathname: '/home',
					}}
				/>
			);
		}
		return <Route>{renderResult}</Route>;
	}
}
